import _isEqual from 'lodash/isEqual';

import {
  getCategoriesPayloadFromLessonForm,
  getLessonCategoryIdsFromApiLesson,
} from 'helpers/getLessonCategoryIdsFromApiLesson';

export const convertDataToForm = (data: any, readOnly: any) => ({
  id: data.id,
  moduleId: data.moduleId,
  courseId: data.courseId,
  status: data.status,
  title: data.title,
  text: data.text,
  leftItem: data.leftItem,
  rightItem: data.rightItem,
  free: data.free,
  categories: getLessonCategoryIdsFromApiLesson(data),
  readOnly,
});

export const convertDataToApi = (data: any) => ({
  title: data.title,
  text: data.text,
  leftItem: data.leftItem,
  rightItem: data.rightItem,
  free: data.free,
  categories: getCategoriesPayloadFromLessonForm(data),
});

export const getChangedProperties = ({
  currentLesson,
  nextLesson,
}: {
  currentLesson: any;
  nextLesson: any;
}) => {
  const properties = [];

  if (currentLesson.title !== nextLesson.title) {
    properties.push('title');
  }

  if (currentLesson.text !== nextLesson.text) {
    properties.push('text');
  }

  if (currentLesson.free !== nextLesson.free) {
    properties.push('free');
  }

  if (!_isEqual(currentLesson.leftItem, nextLesson.leftItem)) {
    properties.push('leftItem');
  }

  if (!_isEqual(currentLesson.rightItem, nextLesson.rightItem)) {
    properties.push('rightItem');
  }

  if (
    !_isEqual(
      [...getLessonCategoryIdsFromApiLesson(currentLesson)].sort(),
      [...getCategoriesPayloadFromLessonForm(nextLesson)].sort(),
    )
  ) {
    properties.push('categories');
  }

  return properties;
};

export const checkQuestionsValidation = (values: any) =>
  values.leftItem?.correct || values.rightItem?.correct;
